import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#auto-refinance-app', App);
